var map = {
	"./Group 22302.png": 1355,
	"./avatar-christmas.webp": 1356,
	"./bottom-bg-christmas.webp": 1357,
	"./btn-active.png": 1358,
	"./content-deco-1.webp": 1359,
	"./content-deco-2.webp": 1360,
	"./content-deco-3.webp": 1361,
	"./content-deco-4.webp": 1362,
	"./deco-3.webp": 1363,
	"./deposit-icon.webp": 1364,
	"./home-icon-active.webp": 1365,
	"./home-icon.webp": 1366,
	"./live-icon-active.webp": 1367,
	"./live-icon.webp": 1368,
	"./master-bg.jpg": 1369,
	"./master-bg.webp": 1370,
	"./me-icon-active.webp": 1371,
	"./me-icon.webp": 1372,
	"./platform.png": 1373,
	"./platform.webp": 1374,
	"./promos-icon-active.webp": 1375,
	"./promos-icon.webp": 1376,
	"./promos.webp": 1377,
	"./service-christmas.webp": 1378,
	"./snowman.webp": 1379,
	"./sponsor-icon-active.webp": 1380,
	"./sponsor-icon.webp": 1381,
	"./title-deco-left.webp": 1382,
	"./title-deco-right.webp": 1383,
	"./tree.webp": 1384,
	"./vip-icon.webp": 1385,
	"./vip.webp": 1386,
	"./withdraw-icon.webp": 1387,
	"./wwr-img.webp": 1388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;